import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-author-description',
  templateUrl: './author-description.component.html',
  styleUrls: ['./author-description.component.scss']
})
export class AuthorDescriptionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
